module.exports = __webpack_public_path__ + "media/svg/bs-3efaa836.svg";